export default __webpack_public_path__ + "static/media/medical_device design_image_2.66b4fecb.webp";